import { combineReducers } from 'redux'

import reporting from './admin/reporting'
import users from './admin/adminUserReducers'
import importer from './admin/importer'
import lessons from './admin/adminLessonReducers'
import maintenance from './admin/systemMaintenanceReducers'
import localOpportunities from './admin/adminLocalOpportunityReducers'
import certifications from './admin/adminCertificationReducers'
import lessonSearch from './admin/adminLessonSearchReducers'
import loader from './admin/adminLoaderReducers'

const admin = combineReducers({
  users,
  reporting,
  importer,
  loader,
  lessons,
  maintenance,
  localOpportunities,
  certifications,
  lessonSearch
})

export default admin
